export default {
  unzugeordneteEingangsrechnungen: '17C4FBD777C',
  freigegebeneEingangsrechnungen: '17C4FBDE356',
  rechnungen_bezahlen: '17C83E44818',
  berechtigungen_verwalten: '180CC371555',
};
